import React from 'react'
import Paper from '@material-ui/core/Paper';
import { DashboardApi } from '../../../api/dashboard_api'
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';

import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, LineChart, Line,
    PieChart, Pie
} from 'recharts';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import NumberFormat from 'react-number-format';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const cardStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});


const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padingLeft: -50,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};



const COLOR_PALLETE = ["#264653",
    "#2a9d8f",
    "#e9c46a",
    "#f4a261",
    "#e76f51",
    "#3d405b",
    "#a8dadc",
    "#457b9d",
    "#1d3557"
];

export class CustomersDashboardView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            top_clients: [], //'id', 'instagram', 'dni', 'last_name', 'total_amount',
                             // 'total_buys', 'avg_per_buy','first_purchase', 'last_purchase', 'buy_frequency']
            total_clients: 0,
            total_recurrent_clients: 0,
            percentage_recurrence: 0,
            month_new_clients: 0,
            month_recurrent_clients: 0,
            prev_month_new_clients: 0,
            percentage_new_clients_month: 0,
            list_new_customers: []

        }
    }

    componentWillMount = () => {
        DashboardApi.getDashboardCustomer()
            .then(response => {
                let data = response.data
                this.setState({total_clients: data.total_clients, top_clients: data.top_clients,
                               total_recurrent_clients: data.total_recurrent_clients, percentage_recurrence: data.percentage_recurrence,
                               month_new_clients: data.month_new_clients, month_recurrent_clients: data.month_recurrent_clients,
                               prev_month_new_clients: data.prev_month_new_clients, percentage_new_clients_month: data.percentage_new_clients_month,
                               list_new_customers: data.list_new_customers})
            }).catch(error=>{
                console.error(response)
            });

    }

    tableHeader = () =>{
      return (
        <TableHead>
          <TableRow>
            <TableCell align="center"><b>instagram</b></TableCell>
            <TableCell align="center"><b>Nombre</b></TableCell>
            <TableCell align="center"><b>Monto total</b></TableCell>
            <TableCell align="center"><b>Cantidad de compras</b></TableCell>
            <TableCell align="center"><b>Promedio monto por compra</b></TableCell>
            <TableCell align="center"><b>Primera compra</b></TableCell>
            <TableCell align="center"><b>Ultima compra</b></TableCell>
            <TableCell align="center"><b>Frecuencia</b></TableCell>
          </TableRow>
        </TableHead>
      )
    }
    tableTop = () => {
      return (<div>
                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                      Top mejores clientes
                </Typography>

                <Table>
                {this.tableHeader()}
                <TableBody>
                  {this.state.top_clients.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{row.instagram}</TableCell>
                      <TableCell align="right">{row.last_name}</TableCell>
                      <TableCell align="right">{row.total_amount}</TableCell>
                      <TableCell align="center">{row.total_buys}</TableCell>
                      <TableCell align="right">{row.avg_per_buy}</TableCell>
                      <TableCell align="center">{row.first_purchase}</TableCell>
                      <TableCell align="center">{row.last_purchase}</TableCell>
                      <TableCell align="center">{row.buy_frequency} dias</TableCell>
                    </TableRow>
                  ))}


                </TableBody>

                </Table>
          </div>)
    }
    tableWorst= () => {
      return (<div>
                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                      Top peores productos
                </Typography>

                <Table>
                {this.tableHeader()}
                <TableBody>
                  {this.state.worst_ever.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{row.id}</TableCell>
                      <TableCell align="center">{row.type}</TableCell>
                      <TableCell align="center">{row.brand} {row.model}</TableCell>
                      <TableCell align="right">{row.stock}</TableCell>
                      <TableCell align="right">{row.sold_items}</TableCell>
                      <TableCell align="right">{row.voided_items}</TableCell>
                      <TableCell align="right">{row.avg_items}</TableCell>
                    </TableRow>
                  ))}


                </TableBody>

                </Table>
          </div>)
    }

    render() {
        return (<div >
                  {this.state.isLoading &&
                      <div style={{ marginTop: 100 }} className="col-md-10 col-md-offset-1">
                          <CircularProgress
                              size={80}
                              color='primary'
                              thickness={3}
                              style={{ display: 'center' }} />
                      </div>
                  }
                  {!this.state.isLoading &&
                        <div>
                          <div class='col-md-12' style={{ marginLeft: -20}}>
                              <div class='col-md-1' />
                              <div class='col-md-3'  style={{marginTop: 20 }}>
                                  <Card className={cardStyles.root}>
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Total clientes
                                          </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                                  {this.state.total_clients}
                                          </Typography>

                                      </CardContent>
                                  </Card>
                              </div>
                              <div class='col-md-1' />
                              <div class='col-md-3' style={{ marginTop: 20 }}>
                              <Card className={cardStyles.root} >
                                  <CardContent>
                                      <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                          Clientes Nuevos Mes
                              </Typography>
                                      <Typography variant="h4" style={{ textAlign: 'center' }}>
                                          {this.state.month_new_clients}
                                      </Typography>
                                      <Typography
                                          variant="body3"
                                          style={{  color: this.state.percentage_new_clients_month > 0 ? "green" : "red", textAlign: 'center', marginLeft: 40  }}
                                      >
                                      {this.state.percentage_new_clients_month}% vs mes previo
                                      </Typography>
                                  </CardContent>
                              </Card>
                              </div>
                              <div class='col-md-1' />
                              <div class='col-md-2' style={{ marginTop: 20 }}>

                                  <Card className={cardStyles.root}>
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Clientes frecuentes
                                  </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                                {this.state.percentage_recurrence}%
                                          </Typography>

                                      </CardContent>
                                  </Card>
                              </div>
                          </div>
                          <div class='col-md-12' style={{ marginLeft: 20, marginTop:50, marginBottom:50}}>
                          <LineChart
                              width={800}
                              height={300}
                              style={{marginLeft: 80, marginBotom:20}}
                              data={this.state.list_new_customers}
                              margin={{
                                top: 5,
                                right: 30,
                                bottom: 5,
                              }}
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Line type="monotone" dataKey="total" stroke="#8884d8" activeDot={{ r: 8 }} />
                            </LineChart>
                              <div class='col-md-12' >
                                  {!this.state.isLoading &&
                                    this.tableTop()
                                  }
                                </div>


                          </div>

                    <br />
                    <br />
                    <br />

                </div>}
                </div>

        )
    }
}

export default CustomersDashboardView



// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard/CustomerDashboardView.js